// Colours for a notice's importance — the admin console and the shop app's announcement banner
// show the same level the same way.
export const SEVERITY_CLASS = {
  critical: "border-danger-500/30 bg-danger-50 text-danger-700 dark:bg-danger-500/10 dark:text-danger-500",
  warning: "border-amber-300 bg-amber-50 text-amber-800 dark:border-amber-500/30 dark:bg-amber-500/10 dark:text-amber-300",
  info: "border-primary-200 bg-primary-50 text-primary-800 dark:border-primary-500/30 dark:bg-primary-500/10 dark:text-primary-300",
};
